// extracted by mini-css-extract-plugin
export default {"m":"fafe1f7e60","title":"_003a534896","feedback_inner_title":"ed355d1d87","textarea":"_372de36d1d","radio":"bf53172350","text":"_10fbc3b1db"};